// Styles for Global Sidebar Layout
export default {
   // Global
   tmpGlobalLayout: 'sidebar',
   tmpHeadingBlockHeight: '160px',
   tmpTitleLgSize: '8',
   tmpTitleMdSize: '6.5',
   tmpTitleMdLetterSpacing: '-0.2px',
   // Button
   tmpPrimaryButtonTextSize: '1.5',
   tmpSecondaryButtonTextSize: '1.5',
   tmpPrimaryButtonHeight: '42px[a-c] 38px[d] 42px[e-f]',
   tmpSecondaryButtonHeight: '40px[a-c] 38px[d] 38px[e-f]',
   // Spacing
   tmpSpacing: '20px',
   tmpSpacingTop: '30px',
   // Viewport Constants
   tmpViewportHeight: `
      calc(100vh - 70px)[a-b]
      calc(100vh - 70px)[c]
      calc(100vh - 0px)[d]
      calc(100vh - 0px)[e-f]
   `,
   tmpContentFixedAreaHeight: `
      calc(100vh - 70px)[a-b]
      calc(100vh - 70px)[c]
      calc(100vh - 0px)[d]
      calc(100vh - 0px)[e-f]
   `,
   tmpViewportPadding: '20px[a] 20px[b] 40px[c] 30px[d] 5vw[e] calc(50vw - 850px + 200px)[f]',
   tmpViewportPaddingA: '20px',
   tmpViewportPaddingB: '20px',
   tmpViewportPaddingC: '40px',
   tmpViewportPaddingD: '30px',
   tmpViewportPaddingE: '5vw',
   tmpViewportPaddingF: 'calc(50vw - 850px + 200px)'
}
